import { isAxiosError } from "axios";
import { CurrentLesson } from "@godalming/api-types";
import { portalApi } from "@services/api/portalApi";

export async function getStudentCurrentLesson(studentNo: string) {
	try {
		const response = await portalApi.get<CurrentLesson>(
			`/students/${studentNo}/current-lesson`,
		);
		return response.data;
	} catch (error) {
		if (
			isAxiosError(error) &&
			error.response?.data?.error === "timetable_unavailable"
		)
			return null;
		console.error("Error fetching student current lesson:", error);
		throw error;
	}
}
